// extracted by mini-css-extract-plugin
module.exports = {"audio-attachment__inner":"audio-attachment__inner__im_cm"};